export default "__VITE_ASSET__c64c078e__"